var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { forwardRef } from "react";
import { useRenameCSS } from "../theme/Theme.js";
export const HeaderCell = forwardRef((_a, ref) => {
    var { className, children, align, textSize } = _a, rest = __rest(_a, ["className", "children", "align", "textSize"]);
    const { cn } = useRenameCSS();
    return (React.createElement("th", Object.assign({ ref: ref, className: cn("navds-table__header-cell", "navds-label", className, {
            [`navds-table__header-cell--align-${align}`]: align,
            "navds-label--small": textSize === "small",
        }) }, rest), children));
});
export default HeaderCell;
//# sourceMappingURL=HeaderCell.js.map